import React from 'react'

interface Enable2FANoticeModalProps {
  heading: string
  description: string
}

const Enable2FANoticeModal = ({ heading, description }: Enable2FANoticeModalProps) => {
  return (
    <>
      <h3 className="text-h3 text-foreground-prominent">{heading}</h3>
      <span className="text-body-regular text-foreground-subdued">{description}</span>
    </>
  )
}

export default Enable2FANoticeModal
